module.exports = __webpack_public_path__ + "img/three3Green.9d6e7c19.jpg";